import { render, staticRenderFns } from "./BrandingConfiguration.vue?vue&type=template&id=141e3e9a&scoped=true"
import script from "./BrandingConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandingConfiguration.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BrandingConfiguration.vue?vue&type=style&index=0&id=141e3e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141e3e9a",
  null
  
)

export default component.exports